import { useState } from "react";
import Numeral from "numeral";
import { uniqBy, some, find } from "lodash-es";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Text from "ab-text";
import ParagraphText from "ab-paragraph-text";
import QuantityPicker from "ab-quantity-picker";
import Personalizacion from "ab-personalizacion";
import Button from "ab-form-button";
import { useCartContext } from "ab-context-cart";
import { useUserContext } from "ab-context-user";

import VinoTile from "./VinoTile";

import "./ab-configurador-estuches.scss";

const ConfiguradorEstuches = ({
  name,
  description,
  price,
  databaseId,
  galleryImages,
  configuradorEstuches,
  i18n,
  stockStatus,
  personalizacion,
  etiquetaSKU,
}) => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [state, dispatch] = useCartContext();
  const { addItemToCart } = dispatch;

  const [userState, userDispatch] = useUserContext();
  const { role } = userState;

  const [personalizeMessage, setPersonalizeMessage] = useState(false);
  const [personalizeEtiqueta, setPersonalizeEtiqueta] = useState(false);
  const [selectedWines, setSelectedWines] = useState([]);
  const [selectedProductos, setSelectedProductos] = useState([]);
  const [tarjetaText, setTarjetaText] = useState("");
  const [etiquetaText, setEtiquetaText] = useState("");
  const [quantity, setQuantity] = useState(1);
  let winesToSelect = new Array(configuradorEstuches.numeroBotellas).fill("");
  let productosToSelect = new Array(
    configuradorEstuches.numeroProductosDeLaFinca || 0
  ).fill("");
  // console.log(
  //   "ConfiguradorEstuches",
  //   configuradorEstuches,
  //   winesToSelect,
  //   selectedWines,
  //   price,
  //   role
  // );

  let tempPrice = 0;
  let tempPriceToShow = Numeral(price).value();
  let customiceLabelPrice = "(+5€)";
  // console.log("estuchePrice", tempPriceToShow);
  selectedWines.map((itm) => {
    tempPrice += Numeral(itm?.price).value();
    tempPriceToShow += Numeral(itm?.price).value();
    // console.log("estuchePrice", tempPriceToShow, itm);
  });

  selectedProductos.map((itm) => {
    tempPrice += Numeral(itm?.price).value();
    tempPriceToShow += Numeral(itm?.price).value();
    // console.log("estuchePrice", tempPriceToShow, itm);
  });

  const notNullSelected = selectedWines.filter((itm) => {
    return itm !== null;
  });
  if (personalizeEtiqueta) {
    tempPriceToShow += 5;
    if (notNullSelected?.length == 1) {
      tempPriceToShow += 1;
    }
    if (notNullSelected?.length == 2) {
      tempPriceToShow += 2;
    }
    if (notNullSelected?.length == 3) {
      tempPriceToShow += 3;
    }
  }
  // Tarjeton
  if (personalizeMessage) {
    tempPriceToShow += 1;
  }

  if (notNullSelected?.length == 1) {
    customiceLabelPrice = "(+6€)";
  }
  if (notNullSelected?.length == 2) {
    customiceLabelPrice = "(+7€)";
  }
  if (notNullSelected?.length == 3) {
    customiceLabelPrice = "(+8€)";
  }

  if (Numeral.locales["abadia"] === undefined) {
    Numeral.register("locale", "abadia", {
      delimiters: {
        thousands: ".",
        decimal: ",",
      },
      abbreviations: {
        thousand: "k",
        million: "mm",
        billion: "b",
        trillion: "t",
      },
      ordinal: function(number) {
        var b = number % 10;
        return b === 1 || b === 3
          ? "er"
          : b === 2
          ? "do"
          : b === 7 || b === 0
          ? "mo"
          : b === 8
          ? "vo"
          : b === 9
          ? "no"
          : "to";
      },
      currency: {
        symbol: "€",
      },
    });
  }

  Numeral.locale("abadia");
  const { t } = useTranslation("common", { i18n });

  return (
    <div className="ab-configurador-estuches">
      <div className="row">
        <div className="image">
          <img src={galleryImages?.nodes?.[0]?.mediaItemUrl} />
        </div>

        <div className="detail">
          <Text element="h2">{name}</Text>
          <ParagraphText content={description} singleColumn />
        </div>
      </div>

      {winesToSelect.map((itm, index) => (
        <div className="wine-row">
          {index == 0 ? (
            <Text element="span" className="title">
              {t("title")}
            </Text>
          ) : null}
          <Text element="h3">
            {index == 0
              ? t("addBottle")
              : index == 1
              ? t("addSecondBottle")
              : t("addThirdBottle")}
          </Text>
          <div className="row">
            {uniqBy(configuradorEstuches.vinos, `producto.databaseId`)?.map(
              (innerItm) => {
                let tempItem = innerItm;

                let hasPrice = find(innerItm?.producto.metaData, [
                  "key",
                  `product_role_based_price_${role}`,
                ]);

                if (hasPrice) {
                  tempItem.producto.price = `${hasPrice.value.replace(
                    ".",
                    ","
                  )}€`;
                }
                // console.log(
                //   "ConfiguradorEstuches - price",
                //   tempItem.price,
                //   Numeral(tempItem?.price).value()
                // );
                return (
                  <VinoTile
                    key={innerItm?.producto?.databaseId}
                    product={tempItem.producto}
                    selected={
                      selectedWines?.[index]?.databaseId ==
                      innerItm?.producto?.databaseId
                    }
                    onClick={() => {
                      let tempSelectedWines = [...selectedWines];
                      // console.log(
                      //   "VinoTile - onClick - ",
                      //   innerItm,
                      //   itm,
                      //   selectedWines?.[index]?.databaseId ==
                      //     innerItm?.producto?.databaseId
                      // );
                      if (
                        selectedWines?.[index]?.databaseId ==
                        innerItm?.producto?.databaseId
                      ) {
                        tempSelectedWines[index] = null;
                      } else {
                        tempSelectedWines[index] = innerItm?.producto;
                      }
                      setSelectedWines(tempSelectedWines);
                    }}
                  />
                );
              }
            )}
          </div>
        </div>
      ))}

      {productosToSelect.map((itm, index) => (
        <div className="wine-row">
          <Text element="h3">
            {index == 0 ? t("addProduct") : t("addAnotherProduct")}
          </Text>
          <div className="row">
            {uniqBy(
              configuradorEstuches.productosDeLaFinca,
              `producto.databaseId`
            )?.map((innerItm) => {
              let tempItem = innerItm;

              let hasPrice = find(innerItm?.producto.metaData, [
                "key",
                `product_role_based_price_${role}`,
              ]);

              if (hasPrice) {
                tempItem.producto.price = `${hasPrice.value.replace(
                  ".",
                  ","
                )}€`;
              }
              console.log("product_role_based_price_", hasPrice);

              return (
                <VinoTile
                  key={innerItm?.producto?.databaseId}
                  product={tempItem.producto}
                  selected={
                    selectedProductos?.[index]?.databaseId ==
                    innerItm?.producto?.databaseId
                  }
                  onClick={() => {
                    let tempSelectedProductos = [...selectedProductos];
                    // console.log(
                    //   "VinoTile - onClick - ",
                    //   innerItm,
                    //   itm,
                    //   selectedWines?.[index]?.databaseId ==
                    //     innerItm?.producto?.databaseId
                    // );
                    if (
                      selectedProductos?.[index]?.databaseId ==
                      innerItm?.producto?.databaseId
                    ) {
                      tempSelectedProductos[index] = null;
                    } else {
                      tempSelectedProductos[index] = innerItm.producto;
                    }
                    setSelectedProductos(tempSelectedProductos);
                  }}
                />
              );
            })}
          </div>
        </div>
      ))}

      <Personalizacion
        personalizeEtiqueta={personalizeEtiqueta}
        setPersonalizeEtiqueta={setPersonalizeEtiqueta}
        etiquetaText={etiquetaText}
        setEtiquetaText={setEtiquetaText}
        personalizeMessage={personalizeMessage}
        setPersonalizeMessage={setPersonalizeMessage}
        setTarjetaText={setTarjetaText}
        tarjetaText={tarjetaText}
        isEven={(winesToSelect.length + productosToSelect.length) % 2 == 0}
        i18n={i18n}
        customiceLabelPrice={customiceLabelPrice}
        configuradorEstuches={configuradorEstuches}
        serviceSKU={personalizacion}
        etiquetaSKU={etiquetaSKU}
        isEstuche={true}
      />

      <div
        className={`add-to-cart-section  ${
          (winesToSelect.length + productosToSelect.length) % 2 == 0
            ? "even"
            : "odd"
        }`}
      >
        <div className="row">
          <QuantityPicker
            quantity={quantity}
            setQuantity={setQuantity}
            i18n={i18n}
          />
          <Text className="title">
            {Numeral(tempPriceToShow * quantity).format("1,000.00$")}
          </Text>
          <Button
            loading={loading}
            disabled={
              stockStatus == "OUT_OF_STOCK" ||
              some(selectedWines, (wine) => !wine?.sku) ||
              selectedWines.length + selectedProductos.length !=
                configuradorEstuches.numeroBotellas +
                  (configuradorEstuches.numeroProductosDeLaFinca || 0)
            }
            onClick={async () => {
              let addons = [];
              setLoading(true);

              addons.push({
                display: `${Numeral(tempPrice * quantity).format(
                  "1,000.00"
                )}&euro;`,
                name: "Estuche - Price",
                price: tempPrice,
                value: tempPrice,
              });

              if (tarjetaText) {
                addons.push({
                  name: "Añadir una tarjeta personalizada",
                  price: "1",
                  value: tarjetaText,
                });
              }

              if (personalizeEtiqueta && etiquetaText) {
                addons.push({
                  name: "Servicio de personalizacion",
                  price: "0",
                  value: "Si",
                });
                addons.push({
                  name: "Texto para la etiqueta",
                  price: "1",
                  value: etiquetaText,
                });
              }

              addons.push({
                name: "Vinos",
                price: "",
                value: selectedWines.map((itm) => itm?.sku).join(),
              });

              addons.push({
                name: "Productos de la Finca",
                price: "",
                value: selectedProductos.map((itm) => itm?.sku).join(),
              });

              let extraData = {
                addons,
              };

              await addItemToCart(
                { databaseId, price: tempPriceToShow },
                quantity,
                null,
                JSON.stringify(extraData)
              );
              if (personalizeEtiqueta && etiquetaText) {
                await addItemToCart(personalizacion, 1, null, null);
              }
              router.push(t("/cesta"));
            }}
          >
            {stockStatus == "OUT_OF_STOCK" ? t("no-stock") : t("addToCart")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfiguradorEstuches;
